<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #list>
        <NoneChevronExpansionPanel>
          <template #header>
            <div class="headerAreaStyle d-flex align-center px-9">
              <div class="headerTitleStyle">
                {{ $t('product.common_currently-tightening-month') }}：<span>{{
                  completeClosingMonth
                }}</span>
              </div>
            </div>
          </template>
          <template #content>
            <div class="contentAreaStyle d-flex align-center">
              <v-row align="center" class="px-9">
                <span>{{
                  $t('product.common_execution-of-tightening-process')
                }}</span>
                <v-col cols="2">
                  <v-select
                    v-model="inputData"
                    :items="closingMonthList"
                    item-text="text"
                    item-value="value"
                    height="32px"
                    dense
                    return-object
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="1">
                  <NormalButton
                    text="common.common_exe"
                    height="32px"
                    width="90px"
                    textSize="14px"
                    @click="registerClosingMonth()"
                  />
                </v-col>
              </v-row>
            </div>
          </template>
        </NoneChevronExpansionPanel>
      </template>
    </Master>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Master } from '@/components/layouts'
import { NoneChevronExpansionPanel } from '@/components/items'
import { NormalButton } from '@/components/items'
import { format } from 'date-fns'
import { subMonths } from 'date-fns'

export default {
  components: {
    Master,
    NoneChevronExpansionPanel,
    NormalButton
  },
  data: () => {
    return {
      pageTitle: 'common.common_tightening-process',
      inputData: { closingMonth: '' },
      completeClosingMonth: '',
      closingMonthList: []
    }
  },
  created() {
    this.getMonthList()
  },
  methods: {
    ...mapActions('User', ['setClosingDate']),
    getMonthList() {
      // 先月から当月の2年前までの年/月を取得する
      for (let getMonthCount = 1; getMonthCount < 25; getMonthCount++) {
        const month = subMonths(new Date(), getMonthCount)
        const formatData = {
          value: format(month, 'YYYY-MM'),
          text: format(month, 'YYYY年MM月まで')
        }
        this.closingMonthList.push(formatData)
      }
    },
    async registerClosingMonth() {
      const formatData = { closingMonth: this.inputData.value }
      const success = await this.setClosingDate(formatData)

      if (success) {
        this.completeClosingMonth = this.inputData.text
      }
    }
  }
}
</script>
<style scoped lang="scss">
.headerTitleStyle {
  font-size: 18px;
  font-weight: bold;
}
.headerAreaStyle {
  height: 70px;
}
.contentAreaStyle {
  height: 83px;
  font-size: 14px;
}

::v-deep .v-input__append-inner {
  margin-top: 4px !important;
}
</style>
